export const WEB_API_GET_DOCUMENTS = 'WEB_API_GET_DOCUMENTS';
export const WEB_API_LOADING = 'WEB_API_LOADING';
export const WEB_API_GET_DOCUMENT_BY_ID = 'WEB_API_GET_DOCUMENT_BY_ID';
export const WEB_API_GET_SECTIONS_BY_ID = 'WEB_API_GET_SECTIONS_BY_ID';
export const WEB_API_GET_RELATED_DOCS_BY_ID = 'WEB_API_GET_RELATED_DOCS_BY_ID';
export const WEB_API_GET_DOC_GLOSSARY_BY_ID = 'WEB_API_GET_DOC_GLOSSARY_BY_ID';
export const WEB_API_GET_SECTION_BY_PAGE_ID = 'WEB_API_GET_SECTION_BY_PAGE_ID';
export const WEB_API_GET_RELATED_SECTION_BY_ID = 'WEB_API_GET_RELATED_SECTION_BY_ID';
export const WEB_API_GET_SUMMARY_BY_DOC_ID = 'WEB_API_GET_SUMMARY_BY_DOC_ID';